var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsistency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53906 17.941C9.53906 22.577 13.3106 26.3478 17.9459 26.3478C22.5819 26.3478 26.3527 22.577 26.3527 17.941C26.3527 13.305 22.5819 9.53418 17.9459 9.53418C13.3106 9.53418 9.53906 13.305 9.53906 17.941ZM24.1596 17.941C24.1596 21.3677 21.3725 24.1547 17.9459 24.1547C14.5199 24.1547 11.7321 21.3677 11.7321 17.941C11.7321 14.5143 14.5199 11.7273 17.9459 11.7273C21.3725 11.7273 24.1596 14.5143 24.1596 17.941Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2928 16.4781L13.7422 18.0287L17.2588 21.5453L22.1461 16.658L20.5956 15.1074L17.2588 18.4441L15.2928 16.4781Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6804 17.7935L31.0981 15.1064L27.5157 17.7935L28.8321 19.5469L29.9481 18.71C29.6783 22.9931 27.2172 26.7832 23.3438 28.7132L24.3204 30.675C28.9677 28.3609 31.899 23.7865 32.1465 18.634L33.3639 19.5469L34.6804 17.7935Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5498 7.0484L18.7131 5.9326C22.9542 6.22789 26.7879 8.66663 28.7162 12.5368L30.6779 11.5602C28.3639 6.91286 23.7894 3.98153 18.6369 3.73408L19.5498 2.51663L17.7957 1.2002L15.1094 4.78252L17.7958 8.36484L19.5498 7.0484Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05133 16.3303L5.93535 17.1672C6.2052 12.8843 8.66635 9.09527 12.5412 7.16393L11.5631 5.20215C6.91579 7.51623 3.98446 12.0907 3.73701 17.2432L2.51956 16.3303L1.20312 18.0836L4.78544 20.7707L8.36776 18.0836L7.05133 16.3303Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3313 28.8316L17.1673 29.9462C12.9244 29.649 9.09525 27.2132 7.16632 23.3418L5.20312 24.3213C7.51855 28.9671 12.0935 31.8983 17.2446 32.146L16.3313 33.3634L18.086 34.6798L20.7724 31.0975L18.086 27.5152L16.3313 28.8316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsistency);
export default __webpack_public_path__ + "static/media/consistency.38aafbd2a3fb83981f1bc0c396e5cc11.svg";
export { ForwardRef as ReactComponent };